<div nz-row [nzGutter]="13" class="w-full">
    <div nz-col [nzSpan]="grid[0]">
        <nz-date-picker
            [ngModel]="fromDate"
            (ngModelChange)="onFromChange($event)"
            [nzDisabledDate]="disableFromDate"
            [nzFormat]="dateFormat"
            [nzPlaceHolder]="fromDatePlaceholder"
            [nzDisabled]="disabled"
            [nzAllowClear]="allowClear"
            [nzInputReadOnly]="readonly"
            [nzShowToday]="false"
            [nzSuffixIcon]="calendarIcon"
        ></nz-date-picker>
    </div>
    <div nz-col [nzSpan]="grid[1]">
        <nz-date-picker
            [ngModel]="toDate"
            (ngModelChange)="onToChange($event)"
            [nzDisabledDate]="disableToDate"
            [nzFormat]="dateFormat"
            [nzPlaceHolder]="toDatePlaceholder"
            [nzDisabled]="disabled"
            [nzAllowClear]="allowClear"
            [nzInputReadOnly]="readonly"
            [nzShowToday]="false"
            [nzSuffixIcon]="calendarIcon"
        ></nz-date-picker>
    </div>
</div>

<ng-template #calendarIcon>
  <img src="/assets/icons/calendar.svg" alt="Calendar">
</ng-template>
